export default __webpack_public_path__ + "static/logo-a295c22bad9e15a79959eccde3c6e5a1.svg";